import type { GridColDef } from '@mui/x-data-grid';
import type { InvoiceOverview } from '@vy/api-definition';
import { INVOICE_TYPES } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';
import type { FieldPath } from 'react-hook-form';
import { Price } from '../../../../../../components/design/Price';
import { formatDate } from '../../../../../../utils/date';

export const SYNC_INVOICES_COLUMNS_KEYS = Object.freeze({
  CUSTOMER_NAME: 'customer.name',
  TOTAL_AMOUNT: 'revenueBreakdown.total',
  ID: 'id',
  ISSUED_AT: 'issuedAt',
} satisfies Record<string, FieldPath<InvoiceOverview>>);

type GetSyncInvoicesColumnsOptions = {
  issueOnEndOfMonth: boolean;
};

export function getSyncInvoicesColumns(options: GetSyncInvoicesColumnsOptions): GridColDef<InvoiceOverview>[] {
  return [
    {
      field: SYNC_INVOICES_COLUMNS_KEYS.CUSTOMER_NAME,
      valueGetter: (_value, row) => row.customer.name,
      headerName: 'Customer name',
      flex: 1,
      renderCell: ({ value }) => <span className="font-sans text-black">{value}</span>,
    },
    {
      field: SYNC_INVOICES_COLUMNS_KEYS.TOTAL_AMOUNT,
      headerName: 'Amount',
      flex: 1,
      renderCell: ({ row }) => {
        const amount = row.revenueBreakdown.total;
        const currency = row.currency;

        return (
          <span className="text-label font-sans">
            <Price currency={currency} className="font-sans text-black">
              {amount}
            </Price>
          </span>
        );
      },
    },
    {
      field: SYNC_INVOICES_COLUMNS_KEYS.ID,
      valueGetter: (_value, row) => row.invoiceNumber,
      headerName: 'Invoice',
      flex: 1,
      renderCell: ({ value }) => <span className="font-sans text-black">{value}</span>,
    },
    {
      field: SYNC_INVOICES_COLUMNS_KEYS.ISSUED_AT,
      headerName: 'Invoice date',
      flex: 1,
      valueGetter: (_value, row) => {
        if (options.issueOnEndOfMonth && row.invoiceType === INVOICE_TYPES.Postpayment) {
          return formatDate(row.billingCycle.endTime);
        }

        return isNotNullOrUndefined(row.issuedAt) ? formatDate(row.issuedAt) : '';
      },
    },
  ];
}
